import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const StreetAddressInput = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <input
        {...generateAttributes(attributes, classes)}
        name="address_line1"
        required
        type="text"
      />
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'billingAddressLine1',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Street Address 1',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: StreetAddressInput,
  style: {
    base: {
      main: checkoutInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  staticBindings,
  fields: {},
});

export default config;
